<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-2">
            <!-- Card stats -->
            <div class="row pt-md-4">
                <div class="col-md-12">
                    <h1>SHA3 Hash Converter</h1>
                </div>

                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.input"
                               placeholder="Enter Value"/>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.output"
                               placeholder="Result Hash SHA3"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12 col-lg-12">
                    <button class="btn btn-dark" @click="calc"><i class="ni ni-sound-wave"></i> Convert</button>
                    <button class="btn btn-primary" @click="clean"><i class="ni ni-button-power"></i> Clear
                    </button>
                    <button v-if="values.output" class="btn btn-info"
                            v-clipboard:copy="values.output"
                            v-clipboard:success="onCopy">
                        <i class="ni ni-ungroup"></i> Copy
                    </button>
                </div>
            </div>

        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--8 bg-dark pb-4">

            <!--Tables-->
            <div class="row mt-5">
                <div class="col-xl-12 mb-12 mb-xl-12">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Latest Results</h3>
                                </div>
                                <div class="col text-right">

                                </div>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <base-table thead-classes="thead-light"
                                        :data="tableData">
                                <template slot="columns">
                                    <th>In</th>
                                    <th>Input Data</th>
                                    <th>Out</th>
                                    <th>Output Data</th>

                                </template>

                                <template slot-scope="{row}">
                                    <th scope="row">
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.input"
                                                v-clipboard:success="onCopy">
                                            {{row.inType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </th>
                                    <th scope="row">
                                        {{row.input}}
                                    </th>
                                    <td>
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.output"
                                                v-clipboard:success="onCopy">
                                            {{row.outType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </td>
                                    <td style="overflow-x:auto;">
                                        {{row.output}}
                                    </td>

                                </template>

                            </base-table>
                        </div>

                    </div>

                    <div v-if="!this.$root.mobile" class="card shadow mt-4 pl-2 pt-2 pb-2 pr-2 bg-gradient-neutral">
                        <h1>SHA-3</h1>
                        <p>
                            SHA-3 (Secure Hash Algorithm 3) is the latest member of the Secure Hash Algorithm family of
                            standards, released by NIST on August 5, 2015. Although part of the same series of
                            standards, SHA-3 is internally different from the MD5-like structure of SHA-1 and SHA-2.
                        </p>
                        <p>
                            SHA-3 is a subset of the broader cryptographic primitive family Keccak (/?k?t??k,
                            -??k/),designed by Guido Bertoni, Joan Daemen, Michael Peeters, and Gilles Van Assche,
                            building upon RadioGatun. Keccak's authors have proposed additional uses for the function,
                            not (yet) standardized by NIST, including a stream cipher, an authenticated encryption
                            system, a "tree" hashing scheme for faster hashing on certain architectures, and AEAD
                            ciphers Keyak and Ketje.
                        </p>
                        <p>
                            Keccak is based on a novel approach called sponge construction.Sponge construction is based
                            on a wide random function or random permutation, and allows inputting ("absorbing" in sponge
                            terminology) any amount of data, and outputting ("squeezing") any amount of data, while
                            acting as a pseudorandom function with regard to all previous inputs. This leads to great
                            flexibility.
                        </p>
                        <p>
                            NIST does not currently plan to withdraw SHA-2 or remove it from the revised Secure Hash
                            Standard. The purpose of SHA-3 is that it can be directly substituted for SHA-2 in current
                            applications if necessary, and to significantly improve the robustness of NIST's overall
                            hash algorithm toolkit.
                        </p>
                    </div>
                </div>
            </div>
            <!--End tables-->
        </div>

    </div>
</template>
<script>
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'

    Vue.use(VueClipboard);
    import CryptoJS from 'crypto-js';

    export default {
        name: "Sha3",
        directives: {
            'b-tooltip': BTooltipDirective
        },
        data() {
            return {
                values: {
                    input: null,
                    output: null
                },
                tableData: [],
            };
        },
        methods: {
            onCopy() {
                this.$notify({
                    type: 'success',
                    title: 'Copied to clipboard'
                })
            },
            revert: function () {

            },
            clean: function () {
                this.values.output = null;
                this.values.input = null;
                this.tableData = [];
            },
            calc: function () {
                if (this.values.input) {
                    this.values.output = (CryptoJS.SHA3(this.values.input)).toString();
                    this.tableData.unshift({
                        input: this.values.input,
                        inType: "string",
                        output: this.values.output,
                        outType: "sha3",
                    });

                    if (this.tableData.length > 8) {
                        this.tableData.splice(8, 1);
                    }
                }
            }
        },
        mounted() {

        }
    };
</script>
<style></style>
